export default "__VITE_ASSET__DzVF3P6g__"